import axios from 'axios'
import nacl from 'tweetnacl';
import naclUtil from 'tweetnacl-util';

function historyPush(val: string) {
  // const history = useHistory()
  return window.location.replace(val)
}

const baseAxios = axios.create({
  baseURL: process.env.REACT_APP_BE_API_URL
})

const refreshTokenUrl = axios.create({
  baseURL: process.env.REACT_APP_BE_API_URL
})

const newService = axios.create()

const keyPair = nacl.box.keyPair();
const publicKey = keyPair.publicKey;
const secretKey = keyPair.secretKey;
const publicKeyString = naclUtil.encodeBase64(publicKey);

newService.interceptors.response.use((response) => {
  return response.data ? response.data : response
}, async (error) => {
  const { response = {} } = error
  const { data } = response
  console.log("🚀 ~ file: baseApi.js:82 ~ BaseApi ~ baseApi.interceptors.response.use ~ data:", response)
  return Promise.reject(data)
})
baseAxios.interceptors.request.use(async (config) => {
  // console.log("🚀 ~ file: axios.tsx:18 ~ baseAxios.interceptors.request.use ~ config", config)
  let session: any = localStorage.getItem('session')
  if (session) {
    session = session ? JSON.parse(session) : null
    const token = session?.token?.access_token
    config.headers = {
      Authorization: 'Bearer ' + token,
      'X-Public-Key': publicKeyString
    }
    return config
  } else {
    return config
  }
}, function (error) {
  return Promise.reject(error)
})

let isRefreshing = false;
let failedQueue: any = [];
console.log("🚀 ~ file: axios.tsx:36 ~ failedQueue", failedQueue)

const processQueue = (error: any, token = null) => {
  failedQueue?.forEach((prom: any) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  })

  failedQueue = [];
}

function handleRefreshToken(error: any, originalRequest: any) {
  let session: any = localStorage.getItem('session')
  console.log("🚀 ~ file: interceptor.js ~ line 16 ~ handleRefreshToken ~ error", error)
  session = session ? JSON.parse(session) : null
  const token = session?.token?.refresh_token
  const HeaderReq = {
    headers: {
      Authorization: `Bearer ${token}`
    }
  }
  return new Promise(function (resolve, reject) {
    refreshTokenUrl.get('/api/internaluser/v1/user/token/refresh', HeaderReq)
      .then(async resdata => {
        console.log("🚀 ~ file: axios.tsx:60 ~ resdata", resdata)
        if (resdata.status === 200) {
          // Save token to localStorage
          const newToken = { ...session, token: resdata?.data?.data }
          window.localStorage.setItem('session', JSON.stringify(newToken));

          // retry request to original 
          if (resdata.data.success === true) {
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + resdata.data?.data?.access_token;
            originalRequest.headers['Authorization'] = 'Bearer ' + resdata.data?.data?.access_token;
            processQueue(null, resdata?.data?.data?.access_token);
            resolve(newService(originalRequest));
          } else {
            processQueue(resdata.data, null);
            reject(resdata.data);
          }
        } else {
          console.log("🚀 ~ file: interceptor.js ~ line 31 ~ err", resdata.data)
          processQueue(resdata.data, null);
          reject(resdata.data);
          historyPush('/signin')
        }
      })
      .catch((err) => {
        console.log("🚀 ~ file: interceptor.js ~ line 31 ~ err", err.response, err)
        processQueue(err.response, null);
        resolve({ data: { message: 'Session Expired' } });
        // historyPush('/login')
      })
      .finally(() => { isRefreshing = false })
  })
}

baseAxios.interceptors.response.use((response) => {
  if (response.config.url === '/api/internaluser/customer/v2/customer') {
    const { data } = response;

    // Decrypt the response
    const decodedNonce = naclUtil.decodeBase64(data.data.nonce);
    const decodedEncryptedMessage = naclUtil.decodeBase64(data.data.data);
    const decodedPrivateKey = naclUtil.decodeBase64(data.data.key);

    if (decodedNonce && decodedEncryptedMessage && decodedPrivateKey) {
      try {
        // Decode Base64

        // Decrypt the message
        const decryptedMessage = nacl.box.open(decodedEncryptedMessage, decodedNonce, decodedPrivateKey, secretKey);

        if (decryptedMessage) {
          const decryptedMessageString = naclUtil.encodeUTF8(decryptedMessage);
          return {
            ...response,
            data: JSON.parse(decryptedMessageString),
          };
        } else {
          throw new Error('Failed to decrypt message');
        }
      } catch (error) {
        console.error('Decryption error:', error);
        return Promise.reject(error);
      }
    } else {
      return response;
    }
  }

  return response?.data ? response?.data : response;

}, async (error) => {
  console.log("Interceptor ~ Error Response", error.response)
  console.log("Interceptor ~ Error", error)
  const originalRequest = error.config;
  const { response = {} } = error
  const { data } = response
  // console.log("🚀 ~ file: axios.tsx:25 ~ baseAxios.interceptors.response.use ~ error", error, originalRequest)
  if (response?.config?.url === "/api/internaluser/v1/user/login") {
    return data
  } else {
    if (response?.config?.url !== `${process.env.REACT_APP_API_URL}/api/internaluser/v1/user/login` && response?.status === 401 && !originalRequest._retry) {
      if (isRefreshing) {
        console.log("🚀 ~ file: axios.tsx:36 ~ baseAxios.interceptors.response.use ~", response)
        return new Promise(function (resolve, reject) {
          failedQueue.push({ resolve, reject })
        }).then(token => {
          console.log("🚀 ~ file: axios.tsx:40 ~ token", token)
          originalRequest.headers['Authorization'] = 'Bearer ' + token;
          return newService(originalRequest);
        }).catch(err => {
          console.log("🚀 ~ file: axios.tsx:44 ~ err", err)
          return Promise.reject(err);
        })
      } else {
        originalRequest._retry = true;
        isRefreshing = true;

        const testres: any = await handleRefreshToken(response, originalRequest)
        console.log("🚀 ~ file: interceptor.js ~ line 139 ~ axios.interceptors.response.use ~ testres", testres)
        return testres?.data?.message === "Session Expired" ? testres?.data : testres
      }
    }
    if (response?.config?.url !== `${process.env.REACT_APP_API_URL}/api/internaluser/v1/user/login` && response?.status === 403) {
      console.log(error.response)
      // historyPush('/signin')
      return data;
    }

    console.log(response)
    const resp = {
      status: 400,
      message: 'Network Error'
    }
    return Promise.reject(data ?? resp)
  }
})

export default baseAxios